import basemat from './basemat/store';
import basematerial from './basematerial/store';
import common from './common/store';
import gltf from './gltf/store';
import ies from './ies/store';
import lum from './lum/store';
import material from './material/store';
import model from './model/store';
import nav from './nav/store';
import scene from './scene/store';
import sectionProduct from './section-product/store';
import submaterial from './submaterial/store';
import supplier from './supplier/store';
import retrieval from './retrieval/store';

export default {
  namespaced: true,
  modules: {
    basemat,
    basematerial,
    common,
    gltf,
    ies,
    lum,
    material,
    model,
    nav,
    retrieval,
    scene,
    sectionProduct,
    submaterial,
    supplier,
  },
};
